import React, { Component } from 'react'
import moment from 'moment'
import classNames from 'classnames'
import enhance from './enhance'
import { formatDate } from 'components/util'
import DatePicker from 'components/date-picker'
import DatePickerLabel from 'components/date-picker-label'
import './schedule-item.css'

class ScheduleItem extends Component {
  constructor(props) {
    super(props)
    this.removeEvent = this.removeEvent.bind(this)
    this.setActiveEvent = this.setActiveEvent.bind(this)
    this.state = { isDeleting: false, isGrowing: false }
  }

  removeEvent() {
    this.setState({ isDeleting: true })
    setTimeout(() => this.props.removeEvent(), 300)
  }

  setActiveEvent() {
    if (this.props.isActive) return
    this.setState({ isGrowing: true })
    setTimeout(() => {
      this.props.setActiveEvent()
    }, 50)
    this.timeout = setTimeout(() => {
      this.setState({ isGrowing: false })
    }, 800)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isActive) {
      this.setState({ isGrowing: false })
    }
  }

  render() {
    const { isDeleting, isGrowing } = this.state
    const {
      id,
      isActive,
      piece,
      event,
      activeEventId,
      removeEvent,
      setStartDate,
      setEndDate,
      isNew,
    } = this.props
    const [startDate, endDate] = [event.startDate, event.endDate].map(date =>
      moment(date),
    )
    const [startDateText, endDateText] = [startDate, endDate].map(date =>
      date.format('MMMM D, YYYY'),
    )
    // date.format('MMMM D h:mm A')
    const active = isActive && 'active'
    const newEvent = isNew && 'new-event'
    const deleting = isDeleting && 'deleting'
    const growing = isGrowing && 'growing'
    const isPast = moment(endDate) < moment() && 'past'
    return (
      <div
        onClick={this.setActiveEvent}
        className={classNames(
          'schedule-item',
          active,
          deleting,
          growing,
          newEvent,
          isPast,
        )}
      >
        <div className="event-top">
          <div className="event-name">
            {piece.name || (
              <div
                style={{
                  height: '20px',
                  width: '50px',
                  backgroundColor: event.contentId,
                  borderRadius: '3px',
                }}
              />
            )}
          </div>
          {isActive && (
            <i
              className="ui icon trash outline delete"
              onClick={this.removeEvent}
              style={{ cursor: 'pointer', fontSize: '20px' }}
            />
          )}
        </div>
        <div className={classNames('event-dates', active, growing)}>
          <div className={classNames('event-date', active)}>
            <DatePickerLabel
              name="add to calendar"
              lineHeight={isActive ? '30px' : '18px'}
            >
              {isActive ? 'Start Date' : 'Starts'}&nbsp;
            </DatePickerLabel>
            {isActive ? (
              <DatePicker
                text={startDateText}
                selectingType="startDate"
                otherType="endDate"
                startDate={startDate}
                endDate={endDate}
                setEventDate={setStartDate}
              />
            ) : (
              <div>{startDateText}</div>
            )}
          </div>
          <div
            className={classNames('event-date', active)}
            style={isActive ? {} : { marginLeft: '16px' }}
          >
            <DatePickerLabel
              name="remove from calendar"
              lineHeight={isActive ? '30px' : '18px'}
            >
              {isActive ? 'End Date' : 'Ends'}&nbsp;
            </DatePickerLabel>
            {isActive ? (
              <DatePicker
                text={endDateText}
                selectingType="endDate"
                otherType="startDate"
                startDate={startDate}
                endDate={endDate}
                setEventDate={setEndDate}
              />
            ) : (
              <div>{endDateText}</div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default enhance(ScheduleItem)



// WEBPACK FOOTER //
// ./src/components/schedule/schedule-item/index.js